import * as React from 'react';

import { ClientPriorityEditorView } from "./clientpriority-editor.view";

interface ClientPriorityEditorControllerProps {
    label?: string;
    mode: ControlMode;
    value: number | null;
    onChanged: (value: number | null) => void;
    required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ClientPriorityEditorController extends React.Component<ClientPriorityEditorControllerProps, any> {
    public constructor(props) {
        super(props);
    }

    public render() {
        return (
            <ClientPriorityEditorView {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/parts/clientpriority-editor.controller.tsx